import * as React from 'react';

export const NoRenewalsIcon = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <defs>
      <path d="M128 64C128 99.3 99.3 128 64 128 28.6 128 0 99.3 0 64 0 28.6 28.6 0 64 0 99.3 0 128 28.6 128 64" />
      <polygon points="0.8 0.6 62.9 0.6 62.9 44.7 0.8 44.7" />
      <polygon points="0.4 0.4 33.7 0.4 33.7 30.6 0.4 30.6" />
      <polygon points="0.4 0.4 33.7 0.4 33.7 30.6 0.4 30.6" />
      <polygon points="0.4 0.4 33.7 0.4 33.7 30.6 0.4 30.6" />
      <polygon points="0.4 0.4 33.7 0.4 33.7 30.6 0.4 30.6" />
    </defs>
    <g fill="none">
      <mask fill="#fff">
        <use xlinkHref="#no-renewals-icon-a" />
      </mask>
      <use xlinkHref="#no-renewals-icon-a" fill="#F8F8F8" />
      <path
        d="M40.6 94.7C40.6 94 40.5 92.6 39.6 91.8L37.1 91.1 33.3 93.3C33.3 93.3 33.7 95.3 34 95.4 34.3 95.5 40.2 95.6 40.2 95.6L40.6 94.7Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M17.4 83.4C17.2 83.2 17.3 82.9 17.6 82.7 17.9 82.6 18.2 82.7 18.3 82.9 18.5 83.2 18.4 83.5 18.1 83.7 17.9 83.8 17.5 83.7 17.4 83.4"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M20.9 82.6C20.8 82.4 20.9 82.3 21 82.2L21.2 82.1C21.4 82 21.5 82.1 21.6 82.2L22 82.9C22.1 83 22 83.2 21.9 83.3L21.6 83.4C21.5 83.5 21.3 83.4 21.3 83.3L20.9 82.6Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M19.2 82.6C19 82.3 19.1 82 19.4 81.9 19.7 81.7 20 81.8 20.1 82.1 20.3 82.4 20.2 82.7 19.9 82.8 19.7 83 19.3 82.9 19.2 82.6"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M18.9 81.7C18.8 81.6 18.8 81.5 19 81.4L19.2 81.2C19.4 81.2 19.5 81.2 19.6 81.3L20 82.1C20 82.2 20 82.4 19.9 82.4L19.6 82.6C19.5 82.6 19.3 82.6 19.3 82.5L18.9 81.7Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M20.9 81.7C20.8 81.4 20.9 81.1 21.1 80.9 21.4 80.8 21.7 80.9 21.9 81.1 22 81.4 21.9 81.7 21.6 81.9 21.4 82 21 81.9 20.9 81.7"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M20.6 80.8C20.5 80.6 20.6 80.5 20.7 80.4L20.9 80.3C21.1 80.2 21.2 80.3 21.3 80.4L21.7 81.1C21.8 81.2 21.7 81.4 21.6 81.5L21.3 81.6C21.2 81.7 21 81.6 21 81.5L20.6 80.8Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M34 95.4C34 94.6 34 93.2 33.1 92.4L30.6 91.6 26.8 93.5C26.8 93.5 27 95.6 27.4 95.7 27.7 95.9 33.5 96.2 33.5 96.2L34 95.4Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M35.5 92.5C35.4 92.3 35.4 92 35.7 91.9 35.9 91.8 36.1 91.9 36.2 92.1 36.3 92.3 36.3 92.6 36 92.7 35.8 92.8 35.6 92.7 35.5 92.5"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M35.2 91.8C35.2 91.7 35.2 91.5 35.3 91.5L35.5 91.4C35.6 91.3 35.8 91.4 35.8 91.5L36.1 92.1C36.2 92.2 36.1 92.3 36 92.4L35.8 92.5C35.7 92.5 35.6 92.5 35.5 92.4L35.2 91.8Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M36.9 91.9C36.8 91.7 36.9 91.4 37.1 91.3 37.4 91.2 37.6 91.3 37.7 91.5 37.8 91.7 37.7 92 37.5 92.1 37.3 92.2 37 92.1 36.9 91.9"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M36.7 91.2C36.7 91.1 36.7 90.9 36.8 90.9L37 90.8C37.1 90.7 37.2 90.8 37.3 90.9L37.6 91.5C37.6 91.6 37.6 91.7 37.5 91.8L37.3 91.9C37.2 91.9 37.1 91.9 37 91.8L36.7 91.2Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M17 82.7C16.9 82.4 17 82.1 17.3 81.9 17.5 81.8 17.9 81.9 18 82.2 18.1 82.5 18 82.8 17.7 82.9 17.5 83 17.1 82.9 17 82.7"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M16.7 81.8C16.7 81.6 16.7 81.5 16.8 81.4L17.1 81.3C17.2 81.2 17.4 81.3 17.5 81.4L17.8 82.2C17.9 82.3 17.8 82.4 17.7 82.5L17.4 82.6C17.3 82.7 17.2 82.6 17.1 82.5L16.7 81.8Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M18.9 81.9C18.7 81.6 18.8 81.3 19.1 81.2 19.4 81.1 19.7 81.2 19.8 81.4 20 81.7 19.9 82 19.6 82.2 19.3 82.3 19 82.2 18.9 81.9"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M18.6 81C18.5 80.9 18.6 80.7 18.7 80.7L19 80.6C19.1 80.5 19.2 80.5 19.3 80.7L19.7 81.4C19.7 81.6 19.7 81.7 19.6 81.8L19.3 81.9C19.2 82 19 81.9 18.9 81.8L18.6 81Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <polygon
        points="82.9 60.8 84.4 62 85.9 59.9 84.4 58.7"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC843"
      />
      <path
        d="M94.3 59.3C94.3 59.3 94.1 59.6 93.5 60 86.8 65 77.5 63.9 77.5 63.9 74.9 63.7 73.5 62.5 72.1 60.7 73.9 59.8 75.2 59.1 75.2 59.1L78 59 93.9 58.3 94.4 58.3C94.4 58.8 94.4 59.1 94.3 59.3"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M73.7 62.2C73.6 62.7 74 63.1 74.5 63 74.4 63 74.1 63.4 74.4 63.8 74.6 64.2 75.3 64 75.9 63.8 75.9 63.8 76 64.4 76.7 64.3 77.5 64.3 77.4 64.1 78.4 63.9 78.5 63.8 78.6 63.8 78.8 63.8 79.8 63.5 81.2 63.1 82 62.4 82.8 61.5 83.2 60.9 84.5 60.2 85.7 59.6 89 58.5 92.7 56.7 95.7 55.2 96.3 53.4 96.8 52.5 97.3 51.3 96.3 47.5 96 45.9 95.8 44.3 94.6 39.2 94.6 39.2L89.4 41.6 90.3 42.2C89.2 42 87.8 41.9 88.3 43.2 89.1 45.2 89.7 47.8 89.9 48.8 90.1 49.7 90 50.2 89.3 51 88.7 51.7 87 53.4 85.8 54.4 84.6 55.3 82.9 56.7 81.5 57.5 80.1 58.3 78.1 58.3 77.3 58.7 76.5 59 74.7 60.8 74 61.3 73.4 61.8 73.3 62.1 73.7 62.2"
        mask="url(#no-renewals-icon-b)"
        fill="#FCD4C6"
      />
      <path
        d="M76.1 64.6L78.6 63.8 77.2 61.8 74.7 61.6 73.7 62.1 73.7 62.1C73.6 62.4 73.5 62.6 73.5 62.9 73.5 63.6 74 64.1 74.6 64.4L75.1 64.6C75.4 64.7 75.8 64.7 76.1 64.6"
        mask="url(#no-renewals-icon-b)"
        fill="#FCD4C6"
      />
      <path
        d="M81.5 59.6C82 58.5 81.5 57.5 81.5 57.5 80.1 58.3 78.1 58.3 77.3 58.7 76.5 59 74.7 60.8 74 61.3 73.3 61.8 73.2 62.2 73.8 62.3 74.4 62.3 75.2 62.1 75.9 61.6 76.7 61.1 77.1 61.4 78.2 61.3 79.3 61.2 79.9 61.6 80.8 60.6 80.8 60.6 81 60.6 81.5 59.6"
        mask="url(#no-renewals-icon-b)"
        fill="#FCD4C6"
      />
      <polygon
        points="83.4 61.8 81.5 59.4 82.7 58.4 84.6 60.8"
        mask="url(#no-renewals-icon-b)"
        fill="#6E6E6E"
      />
      <path
        d="M79.2 58C79.3 56.7 80.5 55.7 81.9 55.8 83.3 55.9 84.3 57.1 84.2 58.5 84 59.9 82.8 60.9 81.5 60.7 80.1 60.6 79.1 59.4 79.2 58"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC72C"
      />
      <path
        d="M80.4 58.1C80.5 57.5 81.1 57 81.8 57 82.5 57.1 83 57.7 82.9 58.4 82.9 59.1 82.3 59.6 81.6 59.5 80.9 59.4 80.4 58.8 80.4 58.1"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <polygon
        points="29.5 63 28.7 63.9 31 66.2 31.9 65.3"
        mask="url(#no-renewals-icon-b)"
        fill="#E6E7E8"
      />
      <polygon
        points="31.1 61.4 30.2 62.3 32.5 64.6 33.4 63.7"
        mask="url(#no-renewals-icon-b)"
        fill="#E6E7E8"
      />
      <path
        d="M41.4 60.8C39.6 60.4 37.7 59 37.2 58.5 36.5 57.8 36 57.1 35.6 55.9 35.2 54.7 35.2 53.2 35.5 52 35.7 51.4 36.1 50.5 36.5 50 37.1 49.1 36.5 48.3 36.3 48 36.2 47.8 35.9 47.5 35.8 47.4 35.4 47.2 34.8 47.6 34.2 48.1 33.7 48.5 33.2 48.9 32.9 49.3L32.7 49.5 31.8 50.5 31.3 51.1C29.7 52.9 29.3 54.5 28.9 56.4 28.6 57.6 28.5 58.6 28.5 59.6 28.4 61.9 28.1 65.5 28.7 66.7 28.7 66.7 28.7 66.8 28.8 66.8 28.8 66.8 30.2 67.1 31.8 67.2 33.2 67.3 34.5 67.3 35.3 66.9 35.3 66.9 36.9 66.5 36.5 66 36.1 65.5 37 65.1 37 63.7 37.1 62.8 38.9 63.3 39.5 62.7 39.9 62.3 41.7 60.9 41.4 60.8"
        mask="url(#no-renewals-icon-b)"
        fill="#3C3C3C"
      />
      <path
        d="M29.3 66.9C28.7 65.8 28.5 64.4 28.6 62.1 28.7 59.3 29 56.9 29.2 55.6 29.5 53.9 30.7 52 31.8 50.6L32.8 49.4C33.5 48.6 35.1 47.4 35.8 47.4L35.8 47.4C34.9 46.7 34.5 46.7 33.8 46.9 33 47.1 31.9 47.7 30.4 49.6 28.1 52.5 27.5 53.9 27 56.3 26.6 58.3 26.4 61.5 26.3 63.5 26.2 65.3 26.6 66.4 27 66.8 27 66.8 27.8 67.1 29.3 66.9"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC72C"
      />
      <path
        d="M35.3 57.5C35.5 57.3 35.9 57.4 36.1 57.6 36.3 57.9 36.2 58.3 35.9 58.5 35.7 58.7 35.3 58.6 35.1 58.3 34.9 58 35 57.7 35.3 57.5"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M36.2 57C36.3 56.9 36.5 57 36.6 57.1L36.8 57.4C36.9 57.5 36.8 57.7 36.7 57.8L35.9 58.3C35.8 58.4 35.6 58.3 35.6 58.2L35.4 57.9C35.3 57.8 35.3 57.7 35.4 57.6L36.2 57Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M34.6 55.3C34.9 55.2 35.2 55.4 35.3 55.7 35.4 56 35.2 56.4 34.9 56.4 34.6 56.5 34.3 56.3 34.2 56 34.1 55.7 34.3 55.4 34.6 55.3"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M35.6 55.2C35.8 55.1 35.9 55.2 36 55.4L36 55.7C36.1 55.9 36 56 35.8 56L35 56.3C34.8 56.3 34.7 56.2 34.6 56.1L34.5 55.8C34.5 55.6 34.6 55.5 34.7 55.4L35.6 55.2Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M34.4 53.1C34.7 53.1 35 53.3 35 53.7 35.1 54 34.8 54.3 34.5 54.3 34.2 54.3 33.9 54.1 33.9 53.7 33.8 53.4 34.1 53.1 34.4 53.1"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M35.4 53.2C35.6 53.2 35.7 53.3 35.7 53.5L35.8 53.8C35.8 53.9 35.6 54.1 35.5 54.1L34.6 54.1C34.4 54.1 34.3 54 34.3 53.9L34.3 53.5C34.2 53.4 34.4 53.3 34.5 53.3L35.4 53.2Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <polygon
        points="34.8 60 32.8 56.9 29.8 58.9 30.5 60.1 32.4 58.9 33.6 60.7"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M71.8 76.3C71.2 75.5 69.9 73.7 68.8 73.1 67.6 72.5 66.5 72.4 65.4 72.2 64.2 71.9 35.5 71.2 35.5 71.2 35.5 71.2 34.5 68.1 35 64.4 35.4 61.8 37 59.1 37.9 58.2 37.9 58.2 46.1 58.7 49.4 58.8 52.8 59 76.3 54.5 81.9 55.7 86.8 56.8 90.8 69.4 90.8 69.4L71.8 76.3Z"
        mask="url(#no-renewals-icon-b)"
        fill="#949499"
      />
      <path
        d="M32.4 68.1C31.3 67.5 30.1 66.7 29.7 66.3 29 65.7 28.4 65.2 27.6 63.9 27 62.8 26.5 61.8 26.3 60.5 26.1 59.6 25.9 58.3 25.9 58 25.9 56.9 25.4 56.4 25.1 56.3 24.5 56.1 24.3 56.1 24.1 56.1 23.5 56.1 23.1 57.1 22.7 57.9L22.5 61.6C21.6 63.7 22 65 22.2 66.8 22.3 67.8 21.7 68.8 22 69.6 22.5 71.6 22.2 75.6 23 76.4 23 76.5 23.1 76.6 23.2 76.6 23.2 76.6 24.7 76.8 26.1 76.5 27.8 76.1 28.9 75.4 30.7 75.1 30.7 75.1 32.3 74.7 31.8 74.4 31.3 74.1 31.6 73.2 31.4 72.1 31.2 71.4 32.1 71.6 32.6 70.9 33 70.4 32.6 68.3 32.4 68.1"
        mask="url(#no-renewals-icon-b)"
        fill="#3C3C3C"
      />
      <path
        d="M23.3 76.6C22.5 75.8 22.6 74.3 22.5 72.2 22.5 69.6 22.6 67.1 22.6 66 22.5 64.5 22.7 62.4 23 60.2 23.1 59 23.5 56.3 24.1 56.1 24.1 56.1 22.7 55.8 22.1 56.1 21.5 56.5 21.3 57.4 21 59.5 20.6 62 20.6 66 20.6 68.4 20.6 70.2 20.6 72.3 20.7 74.3 20.7 76.1 20.9 76.5 21.3 76.7 21.3 76.7 22.1 77 23.3 76.6"
        mask="url(#no-renewals-icon-b)"
        fill="#FFC72C"
      />
      <polygon
        points="28.2 68.6 25.7 66 23.1 68.5 24 69.5 25.6 68 27.1 69.6"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M27.7 65.7C27.9 65.5 28.3 65.5 28.5 65.7 28.7 66 28.7 66.3 28.5 66.6 28.2 66.8 27.8 66.8 27.6 66.5 27.4 66.3 27.4 65.9 27.7 65.7"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M28.5 65.1C28.6 65 28.8 65 28.9 65.1L29.1 65.4C29.2 65.5 29.2 65.7 29.1 65.8L28.4 66.4C28.3 66.5 28.1 66.5 28 66.4L27.8 66.1C27.7 66 27.7 65.9 27.8 65.7L28.5 65.1Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M26.5 64C26.8 63.8 27.2 63.8 27.4 64.1 27.6 64.3 27.5 64.7 27.3 64.9 27 65.1 26.6 65 26.4 64.8 26.2 64.5 26.3 64.1 26.5 64"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M27.4 63.4C27.6 63.4 27.7 63.4 27.8 63.5L28 63.8C28.1 63.9 28.1 64.1 28 64.1L27.2 64.7C27.1 64.8 26.9 64.8 26.9 64.7L26.7 64.4C26.6 64.3 26.6 64.1 26.7 64L27.4 63.4Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M25.7 62C26 61.9 26.4 62 26.5 62.3 26.6 62.6 26.5 62.9 26.2 63.1 25.9 63.2 25.6 63.1 25.4 62.8 25.3 62.5 25.4 62.2 25.7 62"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M26.7 61.7C26.8 61.6 27 61.7 27.1 61.8L27.2 62.1C27.3 62.3 27.2 62.4 27.1 62.5L26.2 62.9C26.1 63 25.9 62.9 25.9 62.8L25.7 62.5C25.7 62.3 25.7 62.2 25.9 62.1L26.7 61.7Z"
        mask="url(#no-renewals-icon-b)"
        fill="#FFF"
      />
      <path
        d="M84.4 88.6C80.6 89.2 77 87.7 75 86.5 71.4 84.4 70 82.7 67 79.8 63 76.1 59.4 75 58.6 75.1 58 75.2 56.6 75.4 52.9 76 51.3 76.2 30.7 79 30.7 79 30.7 79 29.6 79 29 74.4 28.4 69.9 31.1 67.1 31.1 67.1 31.1 67.1 42.5 64.9 46.9 64.1 49.8 63.5 56.3 62.7 59 62.5 61.1 62.4 63.2 62.3 66.7 63.9 70 65.3 77.1 67.4 77.1 67.4L90.7 67.7 90.3 85.9 84.4 88.6Z"
        mask="url(#no-renewals-icon-b)"
        fill="#949499"
      />
      <path
        d="M84.4 88.6C80.6 89.2 77 87.7 75 86.5 71.4 84.4 72.3 80 69.3 77.2 65.3 73.4 62.2 72.7 61.1 72.7 60.4 72.7 55.1 74.8 51.4 75.4 49.8 75.6 30.7 79 30.7 79 30.7 79 29.6 79 29 74.4 28.4 69.9 30 66.3 30 66.3 30 66.3 42.5 64.9 46.9 64.1 49.8 63.5 56.3 62.7 59 62.5 61.1 62.4 63.2 62.3 66.7 63.9 70 65.3 77.1 67.4 77.1 67.4L90.7 67.7 90.3 85.9 84.4 88.6Z"
        mask="url(#no-renewals-icon-b)"
        fill="#949499"
      />
      <path
        d="M92.7 38.5C92.5 37.5 93 36.2 92.5 35.2 92 33.9 91.7 33.5 90.4 33.5 89.5 33.6 88.8 33.7 88.1 33.3 87.5 33 87.1 32.1 87.1 31.1 87.2 30.1 87.1 27.7 87.1 27.7 87.1 27.7 86 27.7 85.9 27.2 85.8 26.7 86.2 26.3 86.6 25.9 87 25.5 87.8 24.6 87.8 24.6 87.8 24.6 88.1 24.2 87.9 23.5 87.6 22.9 87.9 20.5 88.8 19.4 89.7 18.4 91 16.9 94.2 16.8 97.4 16.8 100.2 17.1 101.1 21 102 24.8 100.6 28.9 100.3 29.8 100 30.8 100 31.9 100 32.6 100.1 33.5 100.8 34.8 100.8 34.8L92.7 38.5Z"
        mask="url(#no-renewals-icon-b)"
        fill="#EDA154"
      />
      <path
        d="M103.7 23.1L101.9 22.7 92.3 21C92.1 21.3 92 21.6 92 21.9 92 22.2 92 22.4 92.1 22.7 92.2 22.8 92.2 22.8 92.2 22.9 92.7 23.6 93.5 23.7 93.9 23.8L94 23.8C94.2 23.8 94.3 23.8 94.5 23.7 94.5 23.7 94.6 23.7 94.6 23.6 94.6 23.6 94.7 23.6 94.7 23.6 94.8 23.6 94.8 23.5 94.9 23.5 94.9 23.5 94.9 23.5 94.9 23.5 95 23.5 95 23.4 95.1 23.4 95.2 23.3 95.4 23.3 95.5 23.2L95.5 23.2C95.7 23.2 95.8 23.2 96 23.2 96.5 23.2 96.9 23.4 97.1 24 97.3 24.7 97.1 25.7 96.9 27.3 96.8 28.9 97.8 29.5 98.6 29.6 99.1 29.6 99.5 29.7 100 29.7 100 29.7 100.1 29.7 100.1 29.7 100.5 29.7 101.1 28.8 101.7 28 102.6 26.8 103.5 25.6 103.8 24 103.9 23.9 103.8 23.8 103.8 23.7L103.7 23.1Z"
        mask="url(#no-renewals-icon-b)"
        fill="#3D3C3C"
      />
      <path
        d="M88.2 23.1L95.8 23.2C95.3 23.5 94.8 23.9 94.4 23.9L88.2 23.8 88.2 23.1Z"
        mask="url(#no-renewals-icon-b)"
        style={{ fill: '#3C3C3C', strokeWidth: '0.5', stroke: '#3C3C3C' }}
      />
      <path
        d="M103.9 24L92.2 21.3 87.4 20.2C85.9 19.9 84.9 18.6 84.9 17.1 84.9 16.9 85.2 16.6 85.5 16.7L89.7 17.7C89.7 17.6 92 13.8 98.1 15.2 99.9 15.6 102 16.8 103.1 19.4 103.3 19.9 103.5 20.4 103.6 20.8 104 22.3 104 23.3 103.9 24"
        mask="url(#no-renewals-icon-b)"
        fill="#095ACD"
      />
      <path
        d="M90.8 82.6C90.8 82.6 88.6 82.9 87.2 82.5 84.5 81.7 82 77.8 78.5 75.9 74.5 73.7 69.8 73.6 69.8 73.6 69.8 73.6 71.5 68.1 74.4 62.4 78.8 54 83.9 42.6 88.4 38.7 91.7 35.9 94 34.9 96.7 34.3 96.7 34.3 96.8 34.3 96.9 34.2 99.6 33.6 100.6 34.1 100.6 34.1 104.9 33 104.2 53.2 102.6 59.1 99.8 69.4 90.8 82.6 90.8 82.6"
        mask="url(#no-renewals-icon-b)"
        fill="#FA4816"
      />
      <path
        d="M59.1 35.1C59.1 35.6 59.4 36.1 59.5 36.6 59.5 37 59.3 37.2 59.4 37.6 59.6 38 59.9 38.3 60.1 38.7 60.3 39.4 60 40 60.4 40.6 60.8 41.2 61.4 42 61.9 42.5 62.3 42.9 62.8 43.2 63.3 43.5 63.4 43.6 63.5 43.7 63.6 43.8 63.9 44.1 64.2 44.5 64.5 44.9 64.7 45.2 64.9 45.6 65.1 45.9 66.2 47.4 67.5 48.5 68.9 49.7 69.2 50 70 50.9 70.5 50.6 70.7 50.4 70.9 49.8 71 49.5 71.2 49.1 71.4 48.6 71.6 48.2 71.8 47.7 72 47.2 72.2 46.8 72.4 46.4 72.8 45.8 72.8 45.4 72.7 44.7 71.3 44.4 70.8 44 70 43.5 69.2 42.9 68.4 42.4 68.1 42.2 67.7 42 67.3 41.8 66.9 41.5 66.5 41.2 66.2 40.9 66.2 40.9 66.1 40.8 66.1 40.8 65.2 39.7 65.6 37.8 64.5 36.9 64.1 36.5 63.5 36 62.8 36.3 62.5 36.5 62.3 36.8 62 36.7 61.6 36.6 61.1 36 60.9 35.7 60.6 35.3 60.3 34.2 59.7 34.1 59.1 34 59.1 34.7 59.1 35.1"
        mask="url(#no-renewals-icon-b)"
        fill="#EDA154"
      />
      <path
        d="M62.9 38.9L62.9 38.9C63.1 38.8 63.1 38.6 63 38.5L57.7 29C57.6 28.8 57.4 28.8 57.3 28.9 57.1 29 57.1 29.1 57.2 29.3L62.5 38.8C62.6 38.9 62.8 39 62.9 38.9"
        mask="url(#no-renewals-icon-b)"
        style={{ fill: '#3C3C3C', stroke: '#3C3C3C' }}
      />
      <path
        d="M80.8 65.5C77.6 63.8 75.8 62.7 75.8 62.7L62.4 44.8C62.4 44.8 62.5 43.9 63.2 42.7 63.5 42.4 63.8 42 64.2 41.6 65.5 40.4 66.6 40.1 67 40 67.2 40 67.3 40 67.3 40 68.2 40.9 78.7 50.4 79.9 51.8 81.1 53.1 82.5 54.6 85 55.2L87.4 55.7C89.2 56.2 90.1 58.1 89.5 59.8 89.5 59.8 89.5 59.8 89.5 59.8 88.2 61.4 86.7 63.1 85.2 64.7 85.2 64.7 85.2 64.7 85.1 64.7 84 65.9 82.2 66.2 80.8 65.5"
        mask="url(#no-renewals-icon-b)"
        fill="#FA4816"
      />
      <path
        d="M108.6 40.7L108.6 82.5 82.7 82.5C82.7 82.5 89.2 58 91.4 49.8 95.5 35.1 108.6 40.7 108.6 40.7"
        mask="url(#no-renewals-icon-b)"
        fill="#3C3C3C"
      />
      <g mask="url(#no-renewals-icon-b)">
        <g transform="translate(53.791 61.623)">
          <mask fill="#fff">
            <use xlinkHref="#no-renewals-icon-c" />
          </mask>
          <path
            d="M6.1 6.4L54.8 6.4 54.8 39.2 0.8 39.2 0.8 10.5C0.8 8.2 3.2 6.4 6.1 6.4"
            mask="url(#no-renewals-icon-d)"
            fill="#3C3C3C"
          />
        </g>
      </g>
      <g mask="url(#no-renewals-icon-b)">
        <g transform="translate(7.85 76.085)">
          <mask fill="#fff">
            <use xlinkHref="#no-renewals-icon-e" />
          </mask>
          <path
            d="M19.9 0.4L22.2 0.4C28.2 0.4 29.2 0.9 30.3 2.1 32.4 4.4 33.7 8.7 33.7 12.9 33.7 17.2 32.4 21.4 30.3 23.7 29.2 24.9 28.2 25.5 22.2 25.5L19.9 25.5 17.6 25.5C11.6 25.5 10.6 24.9 9.5 23.7 7.3 21.4 6.1 17.2 6.1 12.9 6.1 8.7 7.3 4.4 9.5 2.1 10.6 0.9 11.6 0.4 17.6 0.4L19.9 0.4Z"
            mask="url(#no-renewals-icon-f)"
            fill="#095ACD"
          />
        </g>
      </g>
      <g mask="url(#no-renewals-icon-b)">
        <g transform="translate(7.85 76.085)">
          <mask fill="#fff">
            <use xlinkHref="#no-renewals-icon-g" />
          </mask>
          <path
            d="M26.3 0.4C27.8 2.5 29.3 9.2 29.3 12.9 29.3 16.6 27.8 23.3 26.3 25.5L21.7 25.5C22.5 23.5 23.1 16.6 23.1 12.9 23.1 9.2 22.5 2.3 21.7 0.4L26.3 0.4Z"
            mask="url(#no-renewals-icon-h)"
            fill="#FFC72C"
          />
        </g>
      </g>
      <g mask="url(#no-renewals-icon-b)">
        <g transform="translate(7.85 76.085)">
          <mask fill="#fff">
            <use xlinkHref="#no-renewals-icon-i" />
          </mask>
          <path
            d="M13.9 0.4C12.3 2.5 10.9 9.2 10.9 12.9 10.9 16.6 12.3 23.3 13.9 25.5L18.5 25.5C17.6 23.5 17.1 16.6 17.1 12.9 17.1 9.2 17.6 2.3 18.5 0.4L13.9 0.4Z"
            mask="url(#no-renewals-icon-j)"
            fill="#FFC72C"
          />
        </g>
      </g>
      <g mask="url(#no-renewals-icon-b)">
        <g transform="translate(7.85 76.085)">
          <mask fill="#fff">
            <use xlinkHref="#no-renewals-icon-k" />
          </mask>
          <path
            d="M80.3-53.5C80.2-53.7 80.1-53.8 79.9-53.8L79.8-53.7C79.6-53.7 79.5-53.5 79.5-53.4L79.9-50.6C80-50.4 80.1-50.3 80.3-50.3L80.4-50.3C80.6-50.3 80.7-50.5 80.7-50.7L80.3-53.5Z"
            mask="url(#no-renewals-icon-l)"
            style={{ fill: '#3C3C3C', strokeWidth: '0.5', stroke: '#3C3C3C' }}
          />
        </g>
      </g>
    </g>
  </svg>
);
